import { render, staticRenderFns } from "./BrandStatistic.vue?vue&type=template&id=4cda42a0&"
import script from "./BrandStatistic.vue?vue&type=script&lang=js&"
export * from "./BrandStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports